<template>
	<div class="class-making-box clearfix">
		<h3 class="f-18 text-nomal">{{applFormType.link && applFormType.name || "신청양식 설정"}}</h3>
		<div class="white-box clearfix" v-if="!applFormType.link">
			<p class="f-14 m-b-5">
				<img src="images/s-check2.png" alt="">
				신청양식 선택
			</p>
			<div class="input-group full-width">
				<span class="input-group-addon p-r-5">
					<select class="form-control-sm m-b-0 round full-width" v-model="data.applForm">
						<option value="">=== 신청양식 선택 ===</option>
						<option v-for="(applForm) in applFormSelect" :value="`${applForm.value}`" :key="`${applForm.value}`">
							{{applForm.name}}
						</option>
					</select>
				</span>
				<!-- <span class="input-group-addon w200 v-mid">
					<button class="btn-sm bg-blue text-white round full-width" type="button" @click="showFormPreview">미리보기</button>
				</span> -->
			</div>
		</div>
		<div class="white-box clearfix" v-if="applFormType.link">
			<p class="f-14 m-b-5">
				<img src="images/s-check2.png" alt="">
				{{applFormType.name}}
			</p>
			<div class="input-group full-width">
				<span class="clearfix">
					<input
						class="form-control-sm round full-width"
						type="text"
						placeholder="링크를 입력해 주세요."
						v-model="data.finishInfo"
					/>
        </span>
			</div>
		</div>
		<!-- button wrapper -->
		<!-- <button class="btn btn-red round m-t-30 pull-left" type="button" @click="setInitValue">초기값으로 설정</button> -->
		<button class="btn bg-deepblue text-white round m-t-30 pull-right" type="button" @click="nextStep">저장하고 넘어가기</button>
		<button class="btn round m-t-30 m-r-5 pull-right" type="button" @click="skipStep">건너뛰기</button>
	</div>
</template>

<script>
import server from '../../statics/server'

export default {
	name: "SubviewClassRegisterStep_6",
	data: function() {
		return {
			data: {
				applForm: this.classData.applForm,
				finishInfo: this.classData.finishInfo,
			},
      applFormType: server.applFormType || {},
			applFormSelect: server.applFormSelect
		}
	},
	props: {
		classData: Object,
		default: Object
	},
	methods: {
		setInitValue: function() {
			this.data.applForm = this.default.applForm;
		},
		skipStep: function() {
			this.$emit("skipStep", {});
		},
		nextStep: function() {
			if(!this.data.applForm && !this.data.finishInfo) {
				if(!this.applFormType.link && !this.data.applForm) {
					this.$emit("alert", "신청양식을 선택하세요.");
					return;
				}
				else {
					this.$emit("alert", "신청양식 링크를 입력 하세요.");
					return;
				}
			}
			this.$emit("nextStep", this.data);
		},
		// showFormPreview: function() {
		// 	this.$emit("preview", this.data.applForm);
		// }
	}
}
</script>

<style>

</style>